import { Link } from 'react-router-dom'
import LegalPageLayout, {
  LegalAddress,
  LegalList,
  LegalSection,
} from '../../../components/legal/LegalPageLayout'
import {
  LEGAL_EFFECTIVE_DATE,
  LEGAL_OPERATOR_NAME,
  LEGAL_SITE_TYPE,
} from '../../../content/legalEntity'
import { usePublicSiteBranding } from '../../../contexts/PublicSiteContext'

export default function TermsOfServicePage() {
  const branding = usePublicSiteBranding()
  const siteName = branding.productDisplayName

  return (
    <LegalPageLayout title="Terms of Service">
      <p className="text-sm font-medium uppercase tracking-wide text-primary">
        {siteName}
      </p>
      <h1 className="mt-2 text-3xl font-extrabold text-marketing-ink">Terms and Conditions</h1>
      <p className="mt-3 text-sm text-gray-600">
        Type of website: {LEGAL_SITE_TYPE}
        <br />
        Effective date: {LEGAL_EFFECTIVE_DATE}
      </p>

      <div className="mt-6 space-y-4 text-base leading-7 text-gray-800">
        <p>
          These terms and conditions (the &quot;Terms and Conditions&quot;) govern the use
          of <strong>{siteName}</strong> (the &quot;Site&quot;). This Site is owned and
          operated by {LEGAL_OPERATOR_NAME}. This Site is a website for a geolocation app.
        </p>
        <p>
          By using this Site, you indicate that you have read and understand these Terms and
          Conditions and agree to abide by them at all times.
        </p>
        <p className="font-semibold">
          THESE TERMS AND CONDITIONS CONTAIN A DISPUTE RESOLUTION CLAUSE THAT IMPACTS YOUR
          RIGHTS ABOUT HOW TO RESOLVE DISPUTES. PLEASE READ IT CAREFULLY.
        </p>
        <p>
          See also our{' '}
          <Link to="/privacy-policy" className="text-primary underline hover:text-primary-dark">
            Privacy Policy
          </Link>
          .
        </p>
      </div>

      <LegalSection title="Intellectual Property">
        <p>
          All content published and made available on our Site is the property of{' '}
          {LEGAL_OPERATOR_NAME} and the Site&apos;s creators. This includes, but is not
          limited to images, text, logos, documents, downloadable files and anything that
          contributes to the composition of our Site.
        </p>
      </LegalSection>

      <LegalSection title="Accounts">
        <p>When you create an account on our Site, you agree to the following:</p>
        <LegalList
          items={[
            'You are solely responsible for your account and the security and privacy of your account, including passwords or sensitive information attached to that account; and',
            'All personal information you provide to us through your account is up to date, accurate, and truthful and that you will update your personal information if it changes.',
          ]}
        />
        <p>
          We reserve the right to suspend or terminate your account if you are using our
          Site illegally or if you violate these Terms and Conditions.
        </p>
      </LegalSection>

      <LegalSection title="Limitation of Liability">
        <p>
          {LEGAL_OPERATOR_NAME} and our directors, officers, agents, employees, subsidiaries,
          and affiliates will not be liable for any actions, claims, losses, damages,
          liabilities and expenses including legal fees from your use of the Site.
        </p>
      </LegalSection>

      <LegalSection title="Indemnity">
        <p>
          Except where prohibited by law, by using this Site you indemnify and hold harmless{' '}
          {LEGAL_OPERATOR_NAME} and our directors, officers, agents, employees, subsidiaries,
          and affiliates from any actions, claims, losses, damages, liabilities and expenses
          including legal fees arising out of your use of our Site or your violation of
          these Terms and Conditions.
        </p>
      </LegalSection>

      <LegalSection title="Applicable Law">
        <p>These Terms and Conditions are governed by the laws of the State of California.</p>
      </LegalSection>

      <LegalSection title="Dispute Resolution">
        <p>
          Subject to any exceptions specified in these Terms and Conditions, if you and{' '}
          {LEGAL_OPERATOR_NAME} are unable to resolve any dispute through informal
          discussion, then you and {LEGAL_OPERATOR_NAME} agree to submit the issue before an
          arbitrator. The decision of the arbitrator will be final and binding. Any
          arbitrator must be a neutral party acceptable to both you and {LEGAL_OPERATOR_NAME}.
          The costs of any arbitration will be shared equally between you and{' '}
          {LEGAL_OPERATOR_NAME}.
        </p>
        <p>
          Notwithstanding any other provision in these Terms and Conditions, you and{' '}
          {LEGAL_OPERATOR_NAME} agree that you both retain the right to bring an action in
          small claims court and to bring an action for injunctive relief or intellectual
          property infringement.
        </p>
      </LegalSection>

      <LegalSection title="Severability">
        <p>
          If at any time any of the provisions set forth in these Terms and Conditions are
          found to be inconsistent or invalid under applicable laws, those provisions will
          be deemed void and will be removed from these Terms and Conditions. All other
          provisions will not be affected by the removal and the rest of these Terms and
          Conditions will still be considered valid.
        </p>
      </LegalSection>

      <LegalSection title="Changes">
        <p>
          These Terms and Conditions may be amended from time to time in order to maintain
          compliance with the law and to reflect any changes to the way we operate our Site
          and the way we expect users to behave on our Site. We will notify users by email
          of changes to these Terms and Conditions or post a notice on our Site.
        </p>
      </LegalSection>

      <LegalSection title="Contact Details">
        <p>Please contact us if you have any questions or concerns. Our contact details are as follows:</p>
        <p className="font-semibold">{LEGAL_OPERATOR_NAME}</p>
        <LegalAddress />
      </LegalSection>
    </LegalPageLayout>
  )
}
